import { AccordionStoryBook } from "@tento-ui/components/accordion.example";
import { AnchorStoryBook } from "@tento-ui/components/anchor.example";
import { AvatarStoryBook } from "@tento-ui/components/avatar.example";
import { BreadcrumbStoryBook } from "@tento-ui/components/breadcrumb/breadcrumb.example";
import { BrowserChromeStoryBook } from "@tento-ui/components/browser-chrome.example";
import { ChatComposerStoryBook } from "@tento-chat/chat/chat-composer.example";
import { ChatThemeStoryBook } from "@tento-chat/chat/chat-theme.example";
import { CodexLookStoryBook } from "@tento-chat/chat/looks/codex.example";
import { ProposalListStoryBook } from "@lona-web/lib/tools/chat/proposal-list.example";
import { RichChatResponseStoryBook } from "@tento-chat/adapters/rich-chat-response.example";
import { DshTurnAskStoryBook } from "@tento-chat/turn-dsh/ask.example";
import { DshTurnAttachmentStoryBook } from "@tento-chat/turn-dsh/attachment.example";
import { DshTurnBarStoryBook } from "@tento-chat/turn-dsh/bar.example";
import { DshKvGridStoryBook } from "@tento-chat/turn-dsh/kv-grid.example";
import { DshTurnNoteStoryBook } from "@tento-chat/turn-dsh/note.example";
import { DshTurnPlanStoryBook } from "@tento-chat/turn-dsh/plan.example";
import { DshTurnPromptStoryBook } from "@tento-chat/turn-dsh/prompt.example";
import { DshTurnProseStoryBook } from "@tento-chat/turn-dsh/prose.example";
import { DshTurnResultStoryBook } from "@tento-chat/turn-dsh/result.example";
import { DshTermBlockStoryBook } from "@tento-chat/turn-dsh/term-block.example";
import { DshTurnThoughtStoryBook } from "@tento-chat/turn-dsh/thought.example";
import { DshTurnToolStoryBook } from "@tento-chat/turn-dsh/tool.example";
import { SessionReplayStoryBook } from "@tento-chat/term/session-replay.example";
import { TermScreenStoryBook } from "@tento-chat/term/term-screen.example";
import { TermTurnAskStoryBook } from "@tento-chat/turn-term/ask.example";
import { TermTurnAttachmentStoryBook } from "@tento-chat/turn-term/attachment.example";
import { TermTurnBarStoryBook } from "@tento-chat/turn-term/bar.example";
import { TermTurnKvGridStoryBook } from "@tento-chat/turn-term/kv-grid.example";
import { TermTurnNoteStoryBook } from "@tento-chat/turn-term/note.example";
import { TermTurnPlanStoryBook } from "@tento-chat/turn-term/plan.example";
import { TermTurnPromptStoryBook } from "@tento-chat/turn-term/prompt.example";
import { TermTurnProseStoryBook } from "@tento-chat/turn-term/prose.example";
import { TermTurnResultStoryBook } from "@tento-chat/turn-term/result.example";
import { TermTurnTermBlockStoryBook } from "@tento-chat/turn-term/term-block.example";
import { TermTurnThoughtStoryBook } from "@tento-chat/turn-term/thought.example";
import { TermTurnToolStoryBook } from "@tento-chat/turn-term/tool.example";
import { TurnAskStoryBook } from "@tento-chat/turn/ask.example";
import { TurnAttachmentStoryBook } from "@tento-chat/turn/attachment.example";
import { TurnBarStoryBook } from "@tento-chat/turn/bar.example";
import { TurnKvGridStoryBook } from "@tento-chat/turn/kv-grid.example";
import { TurnNoteStoryBook } from "@tento-chat/turn/note.example";
import { TurnPlanStoryBook } from "@tento-chat/turn/plan.example";
import { TurnPromptStoryBook } from "@tento-chat/turn/prompt.example";
import { TurnResultStoryBook } from "@tento-chat/turn/result.example";
import { StateDotStoryBook } from "@tento-chat/turn/state-dot.example";
import { TurnTermBlockStoryBook } from "@tento-chat/turn/term-block.example";
import { TurnThoughtStoryBook } from "@tento-chat/turn/thought.example";
import { TurnToolStoryBook } from "@tento-chat/turn/tool.example";
import { AgentTranscriptStoryBook } from "@tento-chat/agent-thinking/transcript.example";
import { ChatPlaygroundStoryBook } from "@tento-chat/dev/chat-playground.example";
import { ThreadFixtureStoryBook } from "@tento-chat/thread/fixture.example";
import { ButtonStoryBook } from "@tento-ui/components/button/button.example";
import { ButtonGroupRowStoryBook } from "@tento-ui/components/button-group-row.example";
import { CalendarColumnStoryBook } from "@tento-ui/components/calendar/calendar-column.example";
import { CalendarColumnCellStoryBook } from "@tento-ui/components/calendar/calendar-column-cell.example";
import { CalendarLegendStoryBook } from "@tento-ui/components/calendar/calendar-legend.example";
import { WeeklyScheduleStoryBook } from "@tento-ui/components/calendar/weekly-schedule.example";
import { CalendarMonthStoryBook } from "@tento-ui/components/calendar-month/calendar-month.example";
import { CalendarMonthInteractiveStoryBook } from "@tento-ui/components/calendar-month/calendar-month.interactive.example";
import { CalendarMonthCellStoryBook } from "@tento-ui/components/calendar-month/calendar-month-cell.example";
import { CarouselStoryBook } from "@tento-ui/components/carousel/carousel.example";
import { CarouselIndicatorStoryBook } from "@tento-ui/components/carousel/carousel-indicator.example";
import { CodeMirrorStoryBook } from "@tento-ui/components/codemirror.example";
import {
  CommitArtifactStoryBook,
  CommitNoteStoryBook,
} from "@tento-ui/components/commit-review/commit-note.example";
import { DiffViewStoryBook } from "@tento-ui/components/diff-view/diff-view.example";
import { GraphGridStoryBook } from "@tento-ui/components/review-notes/graph-grid.example";
import { ReviewCalloutStoryBook } from "@tento-ui/components/review-notes/review-callout.example";
import { ReviewPageHeaderStoryBook } from "@tento-ui/components/review/review-page-header.example";
import { RailStoryBook } from "@tento-ui/components/rail/rail.example";
import { RailSectionStoryBook } from "@tento-ui/components/rail/rail-section.example";
import { SectionTabsStoryBook } from "@tento-ui/components/review/section-tabs.example";
import { AppShellStoryBook } from "@tento-ui/components/shell-layout/app-shell.example";
import { ReviewCompareStoryBook } from "@tento-ui/components/review-notes/review-compare.example";
import { ReviewFlowStoryBook } from "@tento-ui/components/review-notes/review-flow.example";
import { ReviewHtmlStoryBook } from "@tento-ui/components/review-notes/review-html.example";
import { ReviewSeqStoryBook } from "@tento-ui/components/review-notes/review-seq.example";
import { ReviewStateStoryBook } from "@tento-ui/components/review-notes/review-state.example";
import { ReviewStepsStoryBook } from "@tento-ui/components/review-notes/review-steps.example";
import { ReviewTableStoryBook } from "@tento-ui/components/review-notes/review-table.example";
import { PretextDemoStoryBook } from "@tento-ui/components/calendar/pretext-demo.example";
import { ContextMenuStoryBook } from "@tento-ui/components/context-menu.example";
import {
  CheckboxCellStoryBook,
  CheckboxStoryBook,
} from "@tento-ui/components/controls/checkbox.example";
import { DatePickerStoryBook } from "@tento-ui/components/controls/date-picker.example";
import { DropdownStoryBook } from "@tento-ui/components/controls/dropdown.example";
import { InlineSelectStoryBook } from "@tento-ui/components/controls/inline-select.example";
import {
  SliderStoryBook,
  ThickSliderStoryBook,
} from "@tento-ui/components/controls/slider.example";
import { SwitchStoryBook } from "@tento-ui/components/controls/switch.example";
import {
  ThickTwoWaySliderStoryBook,
  TwoWaySliderStoryBook,
} from "@tento-ui/components/controls/two-way-slider.example";
import { AvatarEditableStoryBook } from "@tento-ui/components/core/avatar-editable.example";
import { DocumentationStoryBook } from "@tento-ui/components/documentation/documentation.example";
import { DrawerStoryBook } from "@tento-ui/components/drawer.example";
import { EditableTextStoryBook } from "@tento-ui/components/editable-text.example";
import { DateTimeRangeModalStoryBook } from "@tento-ui/components/event-details/datetime-range-modal.example";
import { EventDetailsContentStoryBook } from "@tento-ui/components/event-details/event-details-content.example";
import { EventDetailsHeaderStoryBook } from "@tento-ui/components/event-details/event-details-header.example";
import { EventDetailsTimeLabelStoryBook } from "@tento-ui/components/event-details/event-details-time-label.example";
import { AddParticipantsFieldStoryBook } from "@tento-ui/components/event-details/fields/add-participants.example";
import { AllDayFieldStoryBook } from "@tento-ui/components/event-details/fields/all-day.example";
import { TagSelectorStoryBook } from "@tento-ui/components/event-details/fields/tag-selector.example";
import { FlightStatusCardStoryBook } from "@tento-ui/components/event-details/flight-status-card.example";
import { EntryListStoryBook } from "@tento-ui/components/entry-list/entry-list.example";
import { EntryRowStoryBook } from "@tento-ui/components/entry-list/entry-row.example";
import { FacepileStoryBook } from "@tento-ui/components/facepile.example";
import { FileTreeStoryBook } from "@tento-ui/components/file-tree/file-tree.example";
import { FlippableCardStoryBook } from "@tento-ui/components/flippable-card.example";
import { FlowContainerStoryBook } from "@tento-ui/components/flow-container.example";
import { GridLayout } from "@tento-ui/components/grid/grid-layout";
import { GridLayoutStoryBook } from "@tento-ui/components/grid/grid-layout.example";
import { HeroLayoutStoryBook } from "@tento-ui/components/hero-layout/hero-layout.example";
import { AllCompleteStateStoryBook } from "@tento-ui/components/home-card/all-complete-state.example";
import { SheetRowCheckmarkCardStoryBook } from "@tento-lona/sheets-ui/storybook";
import { HomeGridCardStoryBook } from "@tento-ui/components/home-card/home-grid-card.example";
import { HomeListCellStoryBook } from "@tento-ui/components/home-card/home-list-cell.example";
import { SheetRowNumberCardStoryBook } from "@tento-ui/components/home-card/number-card.example";
import { SheetRowTextCardStoryBook } from "@tento-ui/components/home-card/text-card.example";
import { TextPromptSubtitleStoryBook } from "@tento-ui/components/home-card/text-prompt-subtitle.example";
import { HtmlEditorStoryBook } from "@tento-ui/components/html-editor.example";
import { IconButtonStoryBook } from "@tento-ui/components/icon-button.example";
import { CardIconStoryBook } from "@tento-ui/components/icons/card-icon.example";
import { ChatIconStoryBook } from "@tento-ui/components/icons/chat-icon.example";
import { LinkIconStoryBook } from "@tento-ui/components/icons/link-icon.example";
import { PomodoroIconStoryBook } from "@tento-ui/components/icons/pomodoro-icon.example";
import { SearchIconStoryBook } from "@tento-ui/components/icons/search-icon.example";
import { SheetsIconStoryBook } from "@tento-ui/components/icons/sheets-icon.example";
import { TasksIconStoryBook } from "@tento-ui/components/icons/tasks-icon.example";
import { ThemePickerIconStoryBook } from "@tento-ui/components/icons/theme-picker-icon.example";
import { TildeIconStoryBook } from "@tento-ui/components/icons/tilde-icon.example";
import { StickerIconStoryBook } from "@tento-ui/components/icons/sticker-icon.example";
import { GlobeIconStoryBook } from "@tento-ui/components/icons/globe-icon.example";
import { HeartIconStoryBook } from "@tento-ui/components/icons/heart-icon.example";
import { ChartIconStoryBook } from "@tento-ui/components/icons/chart-icon.example";
import { CodeInputStoryBook } from "@tento-ui/components/input/code-input.example";
import { ColorInputStoryBook } from "@tento-ui/components/input/color-input.example";
import { DateFieldStoryBook } from "@tento-ui/components/input/date-field.example";
import { DateInputStoryBook } from "@tento-ui/components/input/date-input.example";
import { DatePickerInputStoryBook } from "@tento-ui/components/input/date-picker-input.example";
import { DateTimeFieldStoryBook } from "@tento-ui/components/input/datetime-field.example";
import { DateTimeInputStoryBook } from "@tento-ui/components/input/datetime-input.example";
import { DateTimeRegionInputStoryBook } from "@tento-ui/components/input/datetimeregion-input.example";
import { FormStoryBook } from "@tento-ui/components/input/form.example";
import { HtmlEditorInputStoryBook } from "@tento-ui/components/input/html-editor-input.example";
import { InputLayoutStoryBook } from "@tento-ui/components/input/input-layout.example";
import { NumberInputAccessoryStoryBook } from "@tento-ui/components/input/number-input-accessory.example";
import { PropertyListStoryBook } from "@tento-ui/components/input/property-list.example";
import { RecurrenceInputStoryBook } from "@tento-ui/components/input/recurrence-input.example";
import { SelectInputStoryBook } from "@tento-ui/components/input/select-input.example";
import { SliderInputStoryBook } from "@tento-ui/components/input/slider-input.example";
import { TextAlignmentInputStoryBook } from "@tento-ui/components/input/text-alignment-input.example";
import { TextInputStoryBook } from "@tento-ui/components/input/text-input.example";
import { TextInputMenubarStoryBook } from "@tento-ui/components/input/text-input-menubar.example";
import { TimeFieldStoryBook } from "@tento-ui/components/input/time-field.example";
import { TimeInputStoryBook } from "@tento-ui/components/input/time-input.example";
import { ChartCrosshairOverlayStoryBook } from "@tento-ui/components/line-chart/chart-crosshair-overlay.example";
import { LineChartStoryBook } from "@tento-ui/components/line-chart/line-chart.example";
import { LineChartLegendStoryBook } from "@tento-ui/components/line-chart/line-chart-legend.example";
import { LinkEditPopoverStoryBook } from "@tento-ui/components/link-edit-popover.example";
import { LispExampleStoryBook } from "@tento-ui/components/lisp-example/lisp-example.example";
import { ListStoryBook } from "@tento-ui/components/list/list.example";
import { LogsListStoryBook } from "@tento-ui/components/logging/logs-list.example";
import { ScrollBarStoryBook } from "@tento-ui/components/logging/scroll-bar.example";
import { SpanLineStoryBook } from "@tento-ui/components/logging/span-line.example";
import { SpanRowStoryBook } from "@tento-ui/components/logging/span-row.example";
import { LonaMarketingFaqStoryBook } from "@tento-ui/brand/marketing-faq.example";
import { MetersStoryBook } from "@tento-ui/components/meters/meters.example";
import { MiniWindowStoryBook } from "@tento-ui/components/mini-window.example";
import { PageIndicatorDotsStoryBook } from "@tento-ui/components/page-indicator-dots.example";
import { AuthPageStoryBook } from "@tento-ui/components/pages/auth-page.example";
import { AuthPageStatusStoryBook } from "@tento-ui/components/pages/auth-page-status.example";
import { DeviceAuthCardStoryBook } from "@tento-ui/components/pages/device-auth-card.example";
import { MobileBridgeCardStoryBook } from "@tento-ui/components/pages/mobile-bridge-card.example";
import { OnboardingFlowStoryBook } from "@tento-onboarding/ui/onboarding-flow.example";
import { PageCardStoryBook } from "@tento-ui/components/pages/page-card.example";
import { SimpleAuthCardStoryBook } from "@tento-ui/components/pages/simple-auth-card.example";
import { WebviewEscapeCardStoryBook } from "@tento-ui/components/pages/webview-escape-card.example";
import { PillButtonStoryBook } from "@tento-ui/components/pill-button.example";
import { PillTextInputStoryBook } from "@tento-ui/components/pill-text-input.example";
import { PlanSelectorStoryBook } from "@tento-ui/brand/plan-selector/plan-selector.example";
import { PromoConfirmationViewStoryBook } from "@tento-ui/brand/plan-selector/promo-confirmation-view.example";
import { PlanOptionsViewStoryBook } from "@lona-web/lib/plans/plan-options-view.example";
import { PlotStoryBook } from "@tento-ui/components/plot.example";
import {
  PromptAlertStoryBook,
  PromptStoryBook,
} from "@tento-ui/components/prompt.example";
import { ProseMirrorStoryBook } from "@tento-ui/components/prosemirror.example";
import { RadioButtonCellStoryBook } from "@tento-ui/components/radio-button-cell.example";
import { RecurrenceEditorModalStoryBook } from "@tento-ui/components/recurrence-editor-modal.example";
import { RichTextEditorStoryBook } from "@tento-ui/components/rich-text-editor/rich-text-editor.example";
import { RangeLayoutStoryBook } from "@tento-ui/components/timeline/range-layout.example";
import { RoundStoryBook } from "@tento-ui/components/round.example";
import { SafariBlockStoryBook } from "@tento-ui/components/safari-block/safari-block.example";
import { SessionHeaderStoryBook } from "@tento-ui/components/session/session-header.example";
import { CartesianCoordinateStoryBook } from "@tento-ui/components/scroll/cartesian-coordinate.example";
import { ScrollHorizontalStoryBook } from "@tento-ui/components/scroll/scroll-horizontal.example";
import { ScrollLayoutSnapshotOverlayStoryBook } from "@tento-ui/components/scroll/scroll-layout-snapshot-overlay.example";
import { ScrollVerticalStoryBook } from "@tento-scroll/vertical/scroll-vertical.example";
import { CellGroupStoryBook } from "@tento-ui/components/sheet/cell-group.example";
import { FractionLabelStoryBook } from "@tento-ui/components/fraction-label.example";
import { TextCellStoryBook } from "@tento-lona/sheets-ui/storybook";
import { SheetDebugOverlayStoryBook } from "@tento-ui/components/sheet/dbg-sheet-overlay.example";
import { ShimmerStoryBook } from "@tento-ui/components/shimmer.example";
import { GracePeriodBannerStoryBook } from "@lona-web/lib/core/sidebar/grace-period-banner.example";
import { SidebarContainerStoryBook } from "@tento-ui/components/sidebar/sidebar-container.example";
import { SidebarExpandButtonStoryBook } from "@tento-ui/components/sidebar/sidebar-expand-button.example";
import { SplitButtonsStoryBook } from "@tento-ui/components/split-buttons/split-buttons.example";
import { SpotlightLayoutStoryBook } from "@tento-ui/components/spotlight/spotlight-layout.example";
import { StatusMarkStoryBook } from "@tento-ui/components/status/status-mark.example";
import { SquircleStoryBook } from "@tento-ui/components/squircle/squircle.example";
import { DragDropStoryBook } from "@tento-ui/components/drag-drop.example";
import { StickerArtCatalog } from "@tento-ui/components/sticker/sticker-art-catalog";
import { SidebarStickerSectionStoryBook } from "@tento-ui/components/sticker/sidebar-sticker-section.example";
import { StickerCutoutPreviewStoryBook } from "@tento-ui/components/sticker/sticker-cutout-preview.example";
import { StickerDetailsStoryBook } from "@lona-web/lib/sticker/sticker-details.example";
import { StickerPackingLayoutStoryBook } from "@tento-ui/components/sticker/packing/sticker-packing-layout.example";
import { StickerSheetStoryBook } from "@tento-ui/components/sticker/sticker-sheet.example";
import { StreaksStoryBook } from "@tento-ui/components/streaks.example";
import { TableStoryBook } from "@tento-ui/components/table/table.example";
import { TableFooterStoryBook } from "@tento-ui/components/table/table-footer.example";
import { ThemeContextStoryBook } from "@tento-ui/components/theme-context/theme-context.example";
import { TimeScaleSelectorStoryBook } from "@tento-ui/components/time-scale-selector/time-scale-selector.example";
import { TimerControlsStoryBook } from "@tento-ui/components/timer/timer-controls.example";
import { TimerDisplayStoryBook } from "@tento-ui/components/timer/timer-display.example";
import { TimezoneDropdownStoryBook } from "@tento-ui/components/timezone-dropdown.example";
import { ToastStoryBook } from "@tento-ui/components/toast/toast.example";
import { TransitionStoryBook } from "@tento-ui/components/transition.example";
import { VideoEditModalStoryBook } from "@tento-ui/components/video/video-edit-modal.example";
import { YoutubePlayerStoryBook } from "@tento-ui/components/video/youtube-player.example";
import { YoutubePlaylistStoryBook } from "@tento-ui/components/video/youtube-playlist.example";
import { WeatherAccessoryStoryBook } from "@lona-web/lib/weather/components/weather-accessory.example";
import { WeatherCellStoryBook } from "@tento-ui/components/weather/weather-cell.example";
import { WeatherPreviewStoryBook } from "@tento-ui/components/weather/weather-preview.example";
import { WeatherPreviewCardStoryBook } from "@lona-web/lib/weather/components/weather-preview-card.example";
import { WeatherSubtitleStoryBook } from "@lona-web/lib/weather/components/weather-subtitle.example";
import { WeatherTooltipStoryBook } from "@tento-ui/components/weather/weather-tooltip.example";
import { KernelPickerStoryBook } from "@tento-ui/convolution/kernel-picker.example";
import {
  ConvolutionBoxcarStoryBook,
  ConvolutionEpanechnikovStoryBook,
  ConvolutionGaussianStoryBook,
  ConvolutionHammingStoryBook,
} from "@tento-ui/convolution/kernel-preview.example";
import { BgFgCompatibilityStoryBook } from "@tento-ui/ui/bg-fg-compatibility.example";
import {
  BackgroundsStoryBook,
  DividersStoryBook,
  IconColorsStoryBook,
  InteractiveStatesStoryBook,
  OpacityVariantsStoryBook,
  SemanticColorsStoryBook,
  SystemColorsStoryBook,
  TextColorsStoryBook,
} from "@tento-ui/ui/colors.example";
import { IconsStoryBook } from "@tento-ui/ui/icons.example";
import { PipStoryBook } from "@tento-ui/ui/pip.example";
import { LonaApi } from "@lona-web/lib/api";
import { LonaResources } from "@lona-web/lib/resources";

StickerArtCatalog.configure({
  loadText: (path) => LonaResources.static.text(path),
  loadBytes: (path) => LonaResources.static.bytes(path),
});
// The storybook has no per-user theme store: its event examples colour their
// categories in the default theme through `STORYBOOK_EVENT_PRESENTATION`
// (lib/events/storybook-presentation.ts).
import { Storybook } from "@tento-ui/ui/storybook";
import { TypographyStoryBook } from "@tento-ui/ui/typography.example";
import { NuxHabitCardStoryBook } from "@lona-core/home/controllers/nux-content/habit-card.example";
import { NuxSheetCardStoryBook } from "@lona-core/home/controllers/nux-content/sheet-card.example";
import { NuxThemeCardStoryBook } from "@lona-core/home/controllers/nux-content/theme-card.example";
import { NuxExplainerCardStoryBook } from "@lona-core/home/controllers/nux-content/explainer-card.example";
import { NuxHotkeysCardStoryBook } from "@lona-core/home/controllers/nux-content/hotkeys-card.example";
import { NuxAddTaskCardStoryBook } from "@lona-core/home/controllers/nux-content/add-task-card.example";
import { NuxSchedulingCardStoryBook } from "@lona-core/home/controllers/nux-content/scheduling-card.example";
import { MoreIndicatorStoryBook } from "@lona-events/all-day-events/more-indicator.example";
import { CalendarCategorySelectorStoryBook } from "@lona-events/calendar-category-selector.example";
import { CalendarVisibilitySelectorStoryBook } from "@lona-events/calendar-visibility-selector.example";
import { CalendarListPanelStoryBook } from "@lona-web/lib/settings/components/calendar-list-panel.example";
import { CreateApiKeyPageStoryBook } from "@lona-web/lib/settings/create-api-key-page.example";
import { RsvpStatusListStoryBook } from "@lona-events/components/context-menu/rsvp-status-list.example";
import { DeleteRecurringEventModalStoryBook } from "@lona-events/components/delete-recurring-event-modal.example";
import { EventDescriptionContainerStoryBook } from "@lona-events/components/event-description-container.example";
import { EventFieldsStoryBook } from "@lona-events/components/event-fields.example";
import { EventTooltipStoryBook } from "@lona-events/components/event-tooltip.example";
import { PendingEventSubtitleStoryBook } from "@lona-events/components/pending-event-subtitle.example";
import { QuickAddCardStoryBook } from "@lona-events/components/quick-add-card.example";
import { NewRowOptionsModalStoryBook } from "@lona-sheet/components/new-row-options-modal.example";
import { SheetLispExampleStoryBook, TimescaleModalStoryBook } from "@tento-lona/sheets-ui/storybook";
import { TaskDateDisplayStoryBook } from "@lona-tasks/components/task-date-display.example";
import { TaskPriorityIndicatorStoryBook } from "@lona-tasks/components/task-priority-indicator.example";
import { TaskStatusIndicatorStoryBook } from "@lona-tasks/components/task-status-indicator.example";
import { TaskTableStoryBook } from "@lona-tasks/components/task-table.example";
import { DebugMetadataPanelStoryBook } from "@lona-web/lib/tools/sheet-key/debug-metadata-panel.example";
import { DebugResolvedSheetPanelStoryBook } from "@lona-web/lib/tools/sheet-key/debug-resolved-sheet-panel.example";
import { PillSelectStoryBook } from "@lona-web/lib/tools/sheet-key/pill-select.example";
import { BrandNavDetailsStoryBook } from "@tento-ui/brand/blog/brand-nav-details.example";
import { FeatureCardHeroImagePlaceholderStoryBook } from "@tento-ui/brand/landing/feature-card-hero-image-placeholder.example";
import { FeatureCardHeroStoryBook } from "@tento-ui/brand/landing/feature-card-hero.example";
import { LandingBentoStoryBook } from "@tento-ui/brand/landing/landing-bento.example";
import { LandingBrowserDemoStoryBook } from "@tento-ui/brand/landing/landing-browser-demo.example";
import { LandingCardStoryBook } from "@tento-ui/brand/landing/landing-card.example";
import { LandingComparisonTableStoryBook } from "@tento-ui/brand/landing/landing-comparison-table.example";
import { LandingContentFrameStoryBook } from "@tento-ui/brand/landing/landing-content-frame.example";
import { LandingCtaBlockStoryBook } from "@tento-ui/brand/landing/landing-cta-block.example";
import { LandingFaqStoryBook } from "@tento-ui/brand/landing/landing-faq.example";
import { LandingFeatureGridStoryBook } from "@tento-ui/brand/landing/landing-feature-grid.example";
import { LandingGridStoryBook } from "@tento-ui/brand/landing/landing-grid.example";
import { BrandFooterStoryBook } from "@tento-ui/brand/landing/brand-footer.example";
import { LandingHeroStoryBook } from "@tento-ui/brand/landing/landing-hero.example";
import { LandingIntegrationsStoryBook } from "@tento-ui/brand/landing/landing-integrations.example";
import { LandingMetricStoryBook } from "@tento-ui/brand/landing/landing-metric.example";
import { LandingPillStoryBook } from "@tento-ui/brand/landing/landing-pill.example";
import { LandingSectionStoryBook } from "@tento-ui/brand/landing/landing-section.example";
import { LandingSectionIntroStoryBook } from "@tento-ui/brand/landing/landing-section-intro.example";
import { LandingSocialProofStoryBook } from "@tento-ui/brand/landing/landing-social-proof.example";
import { LandingStickerPlaygroundStoryBook } from "@tento-ui/brand/landing/landing-sticker-playground.example";
import { LandingTestimonialStoryBook } from "@tento-ui/brand/landing/landing-testimonial.example";
import { TimezoneConfirmationModalStoryBook } from "@lona-web/lib/calendar-month/timezone-confirmation-modal.example";
import { PomodoroNotchStoryBook } from "@lona-web/lib/pomodoro/components/notch.example";
import { PomodoroMiniAppStoryBook } from "@lona-web/lib/pomodoro/components/pomodoro-miniapp.example";
import { LonaTimerPageStoryBook } from "@lona-web/lib/pomodoro/components/timer-page.example";
import { CreateSchedulingLinkFormStoryBook } from "@lona-web/lib/scheduling-link/create-scheduling-link-form.example";
import { SchedulingLinkSidebarStoryBook } from "@lona-web/lib/scheduling-link/scheduling-link-sidebar.example";
import { BookingReceiptStoryBook } from "@lona-web/lib/scheduling-link/booking-receipt.example";
import { BookingConfirmationStoryBook } from "@lona-web/routes/booking/booking-confirmation.example";

export type StorybookTabItem = {
  id: string;
  label: string;
  gridConfig: GridLayout.Config;
  items: Storybook[];
};

export namespace StorybookTabItem {
  export const COLORS: StorybookTabItem = {
    id: "colors",
    label: "Colors",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 500,
    },
    items: [
      new SystemColorsStoryBook(),
      new TextColorsStoryBook(),
      new BackgroundsStoryBook(),
      new BgFgCompatibilityStoryBook(),
      new IconColorsStoryBook(),
      new DividersStoryBook(),
      new InteractiveStatesStoryBook(),
      new OpacityVariantsStoryBook(),
      new SemanticColorsStoryBook(),
    ],
  };

  export const CORE: StorybookTabItem = {
    id: "core",
    label: "Core",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new CellGroupStoryBook(),
      new ButtonStoryBook(),
      new AnchorStoryBook(),
      new AccordionStoryBook(),
      new AvatarStoryBook(),
      new AvatarEditableStoryBook(),
      new TypographyStoryBook(),
      new IconsStoryBook(),
      new SquircleStoryBook(),
      new StatusMarkStoryBook(),
      new SessionHeaderStoryBook(),
      new RoundStoryBook(),
      new FacepileStoryBook(),
      new PromptStoryBook(),
      new PromptAlertStoryBook(),
      new ListStoryBook(),
      new ToastStoryBook(),
      new SpotlightLayoutStoryBook(),
      new TransitionStoryBook(),
      new PageIndicatorDotsStoryBook(),
      new PlotStoryBook(),
      new ContextMenuStoryBook(),
      new DragDropStoryBook(),
      new FlowContainerStoryBook(),
      new GridLayoutStoryBook(),
      new IconButtonStoryBook(),
      new ShimmerStoryBook(),
      new FlippableCardStoryBook(),
      new GracePeriodBannerStoryBook(),
      new SidebarContainerStoryBook(),
      new SidebarExpandButtonStoryBook(),
      new SplitButtonsStoryBook(),
      new BrowserChromeStoryBook(),
      new PropertyListStoryBook(),
      new EditableTextStoryBook(),
      new PillButtonStoryBook(),
      new ScrollHorizontalStoryBook(),
      new ScrollVerticalStoryBook(),
      new CarouselStoryBook(),
      new CarouselIndicatorStoryBook(),
      new PipStoryBook(),
      new DrawerStoryBook(),
      new HeroLayoutStoryBook(),
      new FractionLabelStoryBook(),
      new SheetDebugOverlayStoryBook(),
      new BreadcrumbStoryBook(),
      new SafariBlockStoryBook(),
      new StreaksStoryBook(),
      new RangeLayoutStoryBook(),
    ],
  };

  export const CONTROLS: StorybookTabItem = {
    id: "controls",
    label: "Controls",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new SliderStoryBook(),
      new ThickSliderStoryBook(),
      new TwoWaySliderStoryBook(),
      new ThickTwoWaySliderStoryBook(),
      new SwitchStoryBook(),
      new ButtonGroupRowStoryBook(),
      new CheckboxStoryBook(),
      new CheckboxCellStoryBook(),
      new RadioButtonCellStoryBook(),
      new DropdownStoryBook(),
      new InlineSelectStoryBook(),
      new TimezoneDropdownStoryBook(),
      new DatePickerStoryBook(),
      new PillTextInputStoryBook(),
      new PillSelectStoryBook(),
      new NumberInputAccessoryStoryBook(),
    ],
  };

  export const FLIGHT: StorybookTabItem = {
    id: "flight",
    label: "Flight",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [new FlightStatusCardStoryBook(), new DateTimeRangeModalStoryBook()],
  };

  export const EVENTS: StorybookTabItem = {
    id: "events",
    label: "Events",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new QuickAddCardStoryBook(),
      new AddParticipantsFieldStoryBook(),
      new AllDayFieldStoryBook(),
      new TagSelectorStoryBook(),
      new RsvpStatusListStoryBook(),
      new PendingEventSubtitleStoryBook(),
      new EventDescriptionContainerStoryBook(),
      new EventFieldsStoryBook(),
      new EventDetailsTimeLabelStoryBook(),
      new EventDetailsHeaderStoryBook(),
      new EventDetailsContentStoryBook(),
      new DeleteRecurringEventModalStoryBook(),
      new RecurrenceEditorModalStoryBook(),
      new EntryListStoryBook(),
      new EntryRowStoryBook(),
      new TimeScaleSelectorStoryBook(),
      new CalendarVisibilitySelectorStoryBook(),
      new CalendarCategorySelectorStoryBook(),
      new CalendarListPanelStoryBook(),
      new CreateApiKeyPageStoryBook(),
      new CalendarColumnStoryBook(),
      new CalendarColumnCellStoryBook(),
      new CalendarLegendStoryBook(),
      new MoreIndicatorStoryBook(),
      new EventTooltipStoryBook(),
    ],
  };

  export const CALENDAR_MONTH: StorybookTabItem = {
    id: "calendar_month",
    label: "Calendar Month",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 600,
    },
    items: [
      new CalendarMonthStoryBook(),
      new CalendarMonthInteractiveStoryBook(),
      new CalendarMonthCellStoryBook(),
      new TimezoneConfirmationModalStoryBook(),
    ],
  };

  export const CHART: StorybookTabItem = {
    id: "chart",
    label: "Chart",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new LineChartStoryBook(),
      new LineChartLegendStoryBook(),
      new LineChartStoryBook.Points(),
      new ChartCrosshairOverlayStoryBook(),
      new ConvolutionGaussianStoryBook(),
      new ConvolutionHammingStoryBook(),
      new ConvolutionEpanechnikovStoryBook(),
      new ConvolutionBoxcarStoryBook(),
      new KernelPickerStoryBook(),
      new MetersStoryBook(),
    ],
  };

  export const TABLE: StorybookTabItem = {
    id: "table",
    label: "Table",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [new TableStoryBook(), new TableFooterStoryBook()],
  };

  export const VIDEO: StorybookTabItem = {
    id: "video",
    label: "Video",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new YoutubePlayerStoryBook(),
      new YoutubePlaylistStoryBook(),
      new VideoEditModalStoryBook(),
    ],
  };

  export const WEATHER: StorybookTabItem = {
    id: "weather",
    label: "Weather",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new WeatherAccessoryStoryBook(),
      new WeatherCellStoryBook(),
      new WeatherPreviewStoryBook(),
      new WeatherPreviewCardStoryBook(),
      new WeatherSubtitleStoryBook(),
      new WeatherTooltipStoryBook(),
    ],
  };

  export const COORDINATE: StorybookTabItem = {
    id: "coordinate",
    label: "Coordinate System",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 500,
    },
    items: [
      new CartesianCoordinateStoryBook(),
      new ScrollLayoutSnapshotOverlayStoryBook(),
    ],
  };

  export const LANDING: StorybookTabItem = {
    id: "landing",
    label: "Landing",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 500,
    },
    items: [
      new LandingCardStoryBook(),
      new LandingPillStoryBook(),
      new LandingMetricStoryBook(),
      new LandingTestimonialStoryBook(),
      new LandingHeroStoryBook(),
      new LandingBrowserDemoStoryBook(),
      new FeatureCardHeroImagePlaceholderStoryBook(),
      new FeatureCardHeroStoryBook(),
      new LandingBentoStoryBook(),
      new LandingGridStoryBook(),
      new LandingSectionStoryBook(),
      new LandingSectionIntroStoryBook(),
      new LandingFeatureGridStoryBook(),
      new LandingStickerPlaygroundStoryBook(),
      new LandingSocialProofStoryBook(),
      new LandingIntegrationsStoryBook(),
      new LandingComparisonTableStoryBook(),
      new LandingContentFrameStoryBook(),
      new LandingFaqStoryBook(),
      new LandingCtaBlockStoryBook(),
      new BrandFooterStoryBook(),
    ],
  };

  export const PAGES: StorybookTabItem = {
    id: "pages",
    label: "Pages",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 800,
    },
    items: [


      new AuthPageStoryBook(),
      new PageCardStoryBook(),
      new DeviceAuthCardStoryBook(),
      new SimpleAuthCardStoryBook(),
      new MobileBridgeCardStoryBook(),
      new WebviewEscapeCardStoryBook(),
      new OnboardingFlowStoryBook(),
      new LonaMarketingFaqStoryBook(),
      new PlanSelectorStoryBook(),
      new PromoConfirmationViewStoryBook(),
      new PlanOptionsViewStoryBook(),
      new WeeklyScheduleStoryBook(),
    ],
  };

  export const AUTH_STATUS: StorybookTabItem = {
    id: "auth-status",
    label: "Auth Status",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 520,
    },
    items: [
      new AuthPageStatusStoryBook(),
    ],
  };

  export const FORM: StorybookTabItem = {
    id: "form",
    label: "Forms",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new FormStoryBook(),
      new InputLayoutStoryBook(),
      new TextInputStoryBook(),
      new SelectInputStoryBook(),
      new SliderInputStoryBook(),
      // Time components
      new TimeFieldStoryBook(),
      new TimeInputStoryBook(),
      // Date components
      new DateFieldStoryBook(),
      new DateInputStoryBook(),
      // DateTime components
      new DateTimeFieldStoryBook(),
      new DateTimeInputStoryBook(),
      new DateTimeRegionInputStoryBook(),
      new DatePickerInputStoryBook(),
      new RecurrenceInputStoryBook(),
      new ColorInputStoryBook(),
      new CodeInputStoryBook(),
    ],
  };

  export const TASK: StorybookTabItem = {
    id: "task",
    label: "Task",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new TaskTableStoryBook(),
      new TaskPriorityIndicatorStoryBook(),
      new TaskStatusIndicatorStoryBook(),
      new TaskDateDisplayStoryBook(),
    ],
  };

  export const EDITOR: StorybookTabItem = {
    id: "editor",
    label: "Editor",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new HtmlEditorInputStoryBook(),
      new HtmlEditorStoryBook(),
      new LinkEditPopoverStoryBook(),
      new ProseMirrorStoryBook(),
      new RichTextEditorStoryBook(),
      new TextCellStoryBook(),
      new CodeMirrorStoryBook(),
      new DiffViewStoryBook(),
      new CommitNoteStoryBook(),
      new CommitArtifactStoryBook(),
      new GraphGridStoryBook(),
      new ReviewFlowStoryBook(),
      new ReviewSeqStoryBook(),
      new ReviewStateStoryBook(),
      new ReviewCalloutStoryBook(),
      new ReviewCompareStoryBook(),
      new ReviewTableStoryBook(),
      new ReviewStepsStoryBook(),
      new ReviewHtmlStoryBook(),
      new ReviewPageHeaderStoryBook(),
      new SectionTabsStoryBook(),
      new PretextDemoStoryBook(),
      new LispExampleStoryBook(),
      new SheetLispExampleStoryBook(),
      new DocumentationStoryBook(),
      new TextAlignmentInputStoryBook(),
      new TextInputMenubarStoryBook(),
    ],
  };

  export const SCHEDULING_LINK: StorybookTabItem = {
    id: "scheduling-link",
    label: "Scheduling Link",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new SchedulingLinkSidebarStoryBook(),
      new CreateSchedulingLinkFormStoryBook(),
      new BookingReceiptStoryBook(),
      new BookingConfirmationStoryBook(),
    ],
  };

  export const POMODORO: StorybookTabItem = {
    id: "pomodoro",
    label: "Pomodoro",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new PomodoroNotchStoryBook(),
      new LonaTimerPageStoryBook(),
      new PomodoroMiniAppStoryBook(),
      new TimerDisplayStoryBook(),
      new TimerControlsStoryBook(),
    ],
  };

  export const HOME_CARD: StorybookTabItem = {
    id: "home-card",
    label: "Home Card",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new AllCompleteStateStoryBook(),
      new HomeGridCardStoryBook(),
      new HomeListCellStoryBook(),
      new SheetRowTextCardStoryBook(),
      new SheetRowNumberCardStoryBook(),
      new SheetRowCheckmarkCardStoryBook(),
      new TextPromptSubtitleStoryBook(),
      new NuxHabitCardStoryBook(),
      new NuxSheetCardStoryBook(),
      new NuxThemeCardStoryBook(),
      new NuxExplainerCardStoryBook(),
      new NuxHotkeysCardStoryBook(),
      new NuxAddTaskCardStoryBook(),
      new NuxSchedulingCardStoryBook(),
    ],
  };

  export const STICKERS: StorybookTabItem = {
    id: "stickers",
    label: "Stickers",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new StickerCutoutPreviewStoryBook(),
      new StickerPackingLayoutStoryBook(),
      new SidebarStickerSectionStoryBook(),
      new StickerSheetStoryBook(),
      new StickerDetailsStoryBook(),
    ],
  };

  export const SIDEBAR_ICONS: StorybookTabItem = {
    id: "sidebar-icons",
    label: "Sidebar Icons",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new CardIconStoryBook(),
      new ChatIconStoryBook(),
      new SheetsIconStoryBook(),
      new TasksIconStoryBook(),
      new LinkIconStoryBook(),
      new SearchIconStoryBook(),
      new TildeIconStoryBook(),
      new PomodoroIconStoryBook(),
      new ThemePickerIconStoryBook(),
      new StickerIconStoryBook(),
      new GlobeIconStoryBook(),
      new HeartIconStoryBook(),
      new ChartIconStoryBook(),
    ],
  };

  export const SHEETS: StorybookTabItem = {
    id: "sheets",
    label: "Sheets",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [new NewRowOptionsModalStoryBook(), new TimescaleModalStoryBook()],
  };

  export const CHAT: StorybookTabItem = {
    id: "chat",
    label: "Chat",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new ChatPlaygroundStoryBook(),
      new ChatComposerStoryBook(),
      new RichChatResponseStoryBook(),
      new ChatThemeStoryBook(),
      new CodexLookStoryBook(),
      new DshTurnAskStoryBook(), new DshTurnAttachmentStoryBook(), new DshTurnBarStoryBook(), new DshKvGridStoryBook(), new DshTurnNoteStoryBook(), new DshTurnPlanStoryBook(), new DshTurnPromptStoryBook(), new DshTurnProseStoryBook(), new DshTurnResultStoryBook(), new DshTermBlockStoryBook(), new DshTurnThoughtStoryBook(), new DshTurnToolStoryBook(), new SessionReplayStoryBook(), new TermScreenStoryBook(), new TermTurnAskStoryBook(), new TermTurnAttachmentStoryBook(), new TermTurnBarStoryBook(), new TermTurnKvGridStoryBook(), new TermTurnNoteStoryBook(), new TermTurnPlanStoryBook(), new TermTurnPromptStoryBook(), new TermTurnProseStoryBook(), new TermTurnResultStoryBook(), new TermTurnTermBlockStoryBook(), new TermTurnThoughtStoryBook(), new TermTurnToolStoryBook(), new TurnAskStoryBook(), new TurnAttachmentStoryBook(), new TurnBarStoryBook(), new TurnKvGridStoryBook(), new TurnNoteStoryBook(), new TurnPlanStoryBook(), new TurnPromptStoryBook(), new TurnResultStoryBook(), new StateDotStoryBook(), new TurnTermBlockStoryBook(), new TurnThoughtStoryBook(), new TurnToolStoryBook(), new AgentTranscriptStoryBook(), new ChatPlaygroundStoryBook(), new ThreadFixtureStoryBook(),
    ],
  };

  export const DEBUG: StorybookTabItem = {
    id: "debug",
    label: "Debug",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new DebugResolvedSheetPanelStoryBook(),
      new DebugMetadataPanelStoryBook(),
      new LogsListStoryBook(),
      new SpanLineStoryBook(),
      new SpanRowStoryBook(),
      new ScrollBarStoryBook(),
      new FileTreeStoryBook(),
    ],
  };

  /** sidebar(1)-kit: the rail family — the frame, the column it reserves, and
   * the two bodies that go in it. Wide cards: a rail card is a rail beside a
   * content pane, and a body card has to read at 240px and 340px both. */
  export const SIDEBAR: StorybookTabItem = {
    id: "sidebar",
    label: "Sidebar",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 800,
    },
    items: [
      new RailStoryBook(),
      new RailSectionStoryBook(),

    ],
  };

  export const ALL: StorybookTabItem[] = [
    AUTH_STATUS,
    CALENDAR_MONTH,
    CHAT,
    CHART,
    COLORS,
    CONTROLS,
    COORDINATE,
    CORE,
    EDITOR,
    EVENTS,
    FLIGHT,
    FORM,
    HOME_CARD,
    LANDING,
    PAGES,
    POMODORO,
    SCHEDULING_LINK,
    SIDEBAR,
    SIDEBAR_ICONS,
    STICKERS,
    TABLE,
    TASK,
    VIDEO,
    WEATHER,
    DEBUG,
  ];

  export const IN_PROGRESS: StorybookTabItem = {
    id: "in-progress",
    label: "In Progress",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [
      new ProposalListStoryBook(),
      new MiniWindowStoryBook(),
      new ThemeContextStoryBook(),
      new BrandNavDetailsStoryBook(),
    ],
  };

  export const ALL_STORYBOOK: StorybookTabItem = {
    id: "all",
    label: "All",
    gridConfig: {
      ...GridLayout.DEFAULT_CONFIG,
      minWidthPx: 400,
    },
    items: [...ALL.flatMap((t) => t.items), ...IN_PROGRESS.items],
  };

  export const TOP: StorybookTabItem[] = [ALL_STORYBOOK, IN_PROGRESS];
}
